
<template>
    <div>

        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="itme" :name="itme" v-for="(itme,index) in listYear" :key="index + 'year'"></el-tab-pane>
        </el-tabs>

        <el-radio-group v-model="tabPosition" style="margin-top: 20px;" v-for="(itme,index) in listDate" :key="index">
            <el-radio-button @click.native="handleClickTba(itme, $event)" :label="itme">{{itme}}</el-radio-button>
        </el-radio-group>

    </div>
</template>
 
 <script>
 
 import axios from "axios";
 import apiBaseUrl from "../../../config/api";
 import loadingUtils from "../../utils/loading";
 import { put, signatureUrl, getFileNameUUID } from "../../utils/oss";
 import { Guci } from './brothersEvent.js';

 export default {
     props:{
        listYear:{
            default:[],
            type: Array
        },
        listDate:{
            default:[],
            type: Array
        },
     },
     data() {
       return {
          activeName:'',
          tabPosition:'',
       };
     },
   
     mounted() {
        this.activeName = this.handleCuurent(true)
        this.tabPosition = this.handleCuurent(false)
     },  
     
     methods:{
 
        handleClick(e){
            Guci.$emit('GuciBrothers', e.name + this.tabPosition);

        },

        handleClickTba(e,event){
            
            Guci.$emit('GuciBrothers', this.activeName + e);
        },

        handleCuurent(type){
            if(type){
                let currentDate = new Date()
                let currentYear = currentDate.getFullYear()
                return `${currentYear}年`
            }else{
                let currentMonthNumber = new Date().getMonth() + 1
                let monthNames = ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
                let currentMonthName = monthNames[currentMonthNumber - 1]
                let currentMonthNameUpper = currentMonthName.toUpperCase()
                return `${currentMonthNameUpper}`
            }
        },
 
     }
 
 
     
 };
 </script>
 
 <style scoped lang="less">

    /deep/ .is-active{
        font-size: 20px;
    }
   
 
    .no-click {
       pointer-events: none;
     }
 </style>
   


// WEBPACK FOOTER //
// src/AnonymousLetterManagement/components/years.vue